const AlarmCommandEnum = Object.freeze({
    BRIGADA: "PANI", // Brigada
    ABANDONO: "LIGA", // Abandono
    SILENCIAR: "SILE", // Silenciar
    RESTAURAR: "DESL"  // Restaurar
});

export default AlarmCommandEnum;